import { State } from './../state/state';
import { Component, OnInit, Input } from '@angular/core';
import {DispatchState} from './dispatch-state';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { headersToString } from 'selenium-webdriver/http';
import { tokenKey } from '@angular/core/src/view';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { DispatchStateService } from './dispatch-stateService';

@Component({
  selector: 'app-dispatch-state',
  templateUrl: './dispatch-state.component.html',
  styleUrls: ['../app.component.less', './dispatch-state.component.less']
})
export class DispatchStateComponent implements OnInit {
  @Input() state: DispatchState;
  @Input() txt: String;
  states: DispatchState[];
  private location: Location;
  
  constructor(private http: HttpClient,  private route: ActivatedRoute,private stateservice: DispatchStateService) { }

  ngOnInit() {
  }


  save(): void {
   
    this.stateservice.updateState(this.state)
      .subscribe();
  }
  
 getStateById(id: number)
 {
  this.stateservice.getState(id).subscribe(state => this.state = state);
  
 }
  goBack(): void {
    this.location.reload;
  }
}
